module.exports = __webpack_public_path__ + "static/media/re_lp.042381de.jpg";